"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberClassesResponseSchema = exports.MEMBER_CLASS_ORDER_TYPE = exports.MEMBER_CLASS_DISPLAY_TYPE = exports.MEMBER_CLASS_CODE = exports.MEMBER_CLASS_TYPE_CODE = void 0;
var zod_1 = require("zod");
exports.MEMBER_CLASS_TYPE_CODE = {
    SALES: 'SALES',
    FLIGHT: 'FLIGHT',
};
exports.MEMBER_CLASS_CODE = {
    LEVEL_00: 'LEVEL_00',
    LEVEL_01: 'LEVEL_01',
    LEVEL_01_TRIAL: 'LEVEL_01_TRIAL',
    LEVEL_01_TRIAL_NERGET: 'LEVEL_01_TRIAL_NERGET',
    FLIGHT_00: 'FLIGHT_00',
    FLIGHT_01: 'FLIGHT_01',
};
exports.MEMBER_CLASS_DISPLAY_TYPE = {
    GOLD_CLASS: 'GOLD_CLASS',
    GOLD_CLASS_TRIAL: 'GOLD_CLASS_TRIAL',
};
exports.MEMBER_CLASS_ORDER_TYPE = {
    GOLD_CLASS: 'GOLD_CLASS',
    GOLD_CLASS_TRIAL: 'GOLD_CLASS_TRIAL',
    FLIGHT_ORDER: 'FLIGHT_ORDER',
};
exports.MemberClassesResponseSchema = zod_1.z.object({
    memberClassList: zod_1.z.array(zod_1.z.object({
        memberNo: zod_1.z.string(),
        classTypeCode: zod_1.z.enum([exports.MEMBER_CLASS_TYPE_CODE.SALES, exports.MEMBER_CLASS_TYPE_CODE.FLIGHT]),
        classCode: zod_1.z.enum([
            exports.MEMBER_CLASS_CODE.LEVEL_00,
            exports.MEMBER_CLASS_CODE.LEVEL_01,
            exports.MEMBER_CLASS_CODE.LEVEL_01_TRIAL,
            exports.MEMBER_CLASS_CODE.LEVEL_01_TRIAL_NERGET,
            exports.MEMBER_CLASS_CODE.FLIGHT_00,
            exports.MEMBER_CLASS_CODE.FLIGHT_01,
        ]),
        startAt: zod_1.z.string().nullable(),
        endAt: zod_1.z.string().nullable(),
        appliedAt: zod_1.z.string().nullable(),
        firstStartAt: zod_1.z.string().nullable(),
    })),
    displayType: zod_1.z.enum([exports.MEMBER_CLASS_DISPLAY_TYPE.GOLD_CLASS, exports.MEMBER_CLASS_DISPLAY_TYPE.GOLD_CLASS_TRIAL]).nullable(),
    globalOrderType: zod_1.z
        .enum([
        exports.MEMBER_CLASS_ORDER_TYPE.GOLD_CLASS,
        exports.MEMBER_CLASS_ORDER_TYPE.GOLD_CLASS_TRIAL,
        exports.MEMBER_CLASS_ORDER_TYPE.FLIGHT_ORDER,
    ])
        .nullable(),
});
